import { AppBar, Box, Grid, Toolbar } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import useIsPayNowEnabled from '../Quote/useIsPayNowEnabled';
import { Dispatch, iRootState } from '../redux/store';
import AttachmentsMenu from './AttachmentMenu/AttachmentsMenu';
import AttachmentsMenuButton from './AttachmentMenu/AttachmentsMenuButton';
import CurrencyPayBadge from './CurrencyPayBadge';
import QuoteTitle from './QuoteTitle';
import useOnPaymentPage from './useOnPaymentPage';
import PaymentScheduleBadge from './PaymentScheduleBadge';
import { QuoteStatuses } from '../constants';
import { PaymentTermStatus } from '../redux/models/paymentTerms';

type MatchParams = {
  quoteId: string;
};

const Header = function Header(): React.ReactElement {
  const attachments = useSelector(
    (state: iRootState) => state.quote.attachments
  );
  const hasTerms = useSelector(
    (state: iRootState) => state.paymentTerms.terms.length > 0
  );
  const terms = useSelector((state: iRootState) => state.paymentTerms.terms);
  const anyPaid = terms.some(
    t =>
      t.paymentStatus === PaymentTermStatus.Paid ||
      t.paymentStatus === PaymentTermStatus.Pending ||
      t.paymentStatus === PaymentTermStatus.UnderReview
  );

  const status = useSelector((state: iRootState) => state.quote.status);

  const match = useRouteMatch<MatchParams>('/quote/:quoteId');
  const quoteId = match?.params.quoteId;
  const dispatch = useDispatch<Dispatch>();

  useEffect(() => {
    if (quoteId) {
      dispatch.quote.getQuoteRecord(quoteId);
      dispatch.quote.getQuoteDocument(quoteId);
      dispatch.paymentTerms.getPaymentTerms(quoteId);
    }
  }, [dispatch.paymentTerms, dispatch.quote, quoteId]);

  const isPayNowEnabled = useIsPayNowEnabled();
  const onPaymentSchedulePage = useOnPaymentPage();
  const showAttachments = attachments.length > 0 && !onPaymentSchedulePage;
  const showCurrencyPayBadge =
    isPayNowEnabled && !onPaymentSchedulePage && !anyPaid;

  const showPaymentScheduleBadge =
    hasTerms &&
    anyPaid &&
    status === QuoteStatuses.Accepted &&
    !onPaymentSchedulePage;

  return (
    <Box displayPrint='none'>
      <AppBar>
        <Toolbar>
          <Grid container justify='space-between' alignItems='center'>
            <Grid item>
              <QuoteTitle />
            </Grid>
            <Grid item>
              {showCurrencyPayBadge && <CurrencyPayBadge />}
              {showPaymentScheduleBadge && <PaymentScheduleBadge />}
            </Grid>
            <Grid item>{showAttachments && <AttachmentsMenuButton />}</Grid>
          </Grid>
          <AttachmentsMenu />
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
